// Environment para desarrollo (local/dev)
export const environment = {
  production: false,
  apiUrl: 'https://dev.api.portaldoca.sdidev.es/api/v1',
  useMockApi: false, // Activar mock API en desarrollo
};
